import { signalSummary } from '../../logic/signalCounts';
import { NetworkError } from '../../data/api';
import { listSignals } from '../../data/signals';
import { onSyncStatus } from '../../data/sync';
import { formatDate, todayLocal } from '../../logic/dates';
import { signalEventLabel } from '../../logic/signals';
import { empty, row, section } from '../../ui/components';
import { h, replaceChildren } from '../../ui/dom';
import { SIGNALS_EMPTY_HINT } from '../../ui/labels';
import { cardLink } from './cardLink';

const PREVIEW = 3;

/** New businesses waiting for triage (D57, D72): how many are worth a visit, and the three the sort put
 *  first. They live on the server, so the card fills in when online and says so when not; it survives
 *  Home re-renders and loads once per visit. */
export const signalsCard = (): { el: HTMLElement; dispose: () => void } => {
  const body = h('div', { class: 'sigpreview' }, h('p', { class: 'card__summary' }, 'Checking…'));
  const el = section({ title: 'New businesses', action: cardLink('See all', '#/signals') }, body);
  let alive = true;
  let failed = false;
  const today = todayLocal();
  const load = () =>
    listSignals('new')
      .then((list) => {
        const { signals } = list;
        if (!alive) return;
        failed = false;
        const top = signals.filter((s) => s.bucket === 'top').length;
        replaceChildren(
          body,
          signals.length === 0
            ? empty("You're caught up.", SIGNALS_EMPTY_HINT)
            : [
                h(
                  'p',
                  { class: 'card__summary' },
                  `${top ? `${top} worth a visit · ` : ''}${signalSummary(list).total} to review`,
                ),
                ...signals.slice(0, PREVIEW).map((s) =>
                  row({
                    title: s.business_name,
                    meta: [signalEventLabel(s), s.city, `filed ${formatDate(s.filed_on, today)}`]
                      .filter(Boolean)
                      .join(' · '),
                    href: `#/signals?id=${encodeURIComponent(s.id)}`,
                  }),
                ),
              ],
        );
      })
      .catch((err: unknown) => {
        if (!alive) return;
        failed = true;
        replaceChildren(
          body,
          h(
            'p',
            { class: 'card__summary' },
            err instanceof NetworkError ? 'Needs a connection to check.' : 'Could not load new businesses.',
          ),
        );
      });
  void load();
  // the API was unreachable when Home opened: fill in once a sync gets through (the request outcome
  // says the connection is back, not navigator.onLine — D68)
  const offSync = onSyncStatus((s) => {
    if (failed && s.state === 'idle') void load();
  });
  return {
    el,
    dispose: () => {
      alive = false;
      offSync();
    },
  };
};
